var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_45310_201176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8646 0.785156H1.86458C1.1282 0.785156 0.53125 1.38211 0.53125 2.11849V23.1185C0.53125 23.8549 1.1282 24.4518 1.86458 24.4518H22.8646C23.601 24.4518 24.1979 23.8549 24.1979 23.1185V2.11849C24.1979 1.38211 23.601 0.785156 22.8646 0.785156Z",
    stroke: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8698 19.2852H3.86979C3.77774 19.2852 3.70312 19.3598 3.70312 19.4518C3.70312 19.5439 3.77774 19.6185 3.86979 19.6185H20.8698C20.9618 19.6185 21.0365 19.5439 21.0365 19.4518C21.0365 19.3598 20.9618 19.2852 20.8698 19.2852Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_45310_201176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9979 5.61719C11.177 5.61719 11.3244 5.75268 11.3433 5.92673L11.3453 5.96458L11.3452 6.58385H12.8104C13.3172 6.58385 13.7314 6.98 13.7604 7.47951L13.762 7.53542V15.0271C13.762 15.5526 13.3359 15.9786 12.8104 15.9786H5.31875C4.79322 15.9786 4.36719 15.5526 4.36719 15.0271V7.53542C4.36719 7.00988 4.79322 6.58385 5.31875 6.58385H6.78385V5.96458C6.78385 5.77272 6.93939 5.61719 7.13125 5.61719C7.31032 5.61719 7.45775 5.75268 7.47661 5.92673L7.47865 5.96458L7.47852 6.58385H10.6505V5.96458C10.6505 5.77272 10.8061 5.61719 10.9979 5.61719ZM13.0672 10.1785H5.06185L5.06198 15.0271C5.06198 15.1571 5.15858 15.2645 5.28391 15.2815L5.31875 15.2839H12.8104C12.9522 15.2839 13.0672 15.1689 13.0672 15.0271V10.1785ZM6.78385 7.27852L5.31875 7.27865C5.17694 7.27865 5.06198 7.39361 5.06198 7.53542L5.06185 9.48385H13.0672V7.53542C13.0672 7.40542 12.9706 7.29799 12.8453 7.28099L12.8104 7.27865L11.3452 7.27852L11.3453 7.89792C11.3453 8.08978 11.1898 8.24531 10.9979 8.24531C10.8188 8.24531 10.6714 8.10982 10.6526 7.93577L10.6505 7.89792V7.27852H7.47852L7.47865 7.89792C7.47865 8.08978 7.32311 8.24531 7.13125 8.24531C6.95218 8.24531 6.80475 8.10982 6.78589 7.93577L6.78385 7.89792V7.27852Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_45310_201176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.367188 0.617188)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_45310_201176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.6667,
    height: 10.6667,
    fill: "white",
    transform: "translate(3.70312 5.61719)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date-icon.c6dab540014711964c64b23299ac3b37.svg";
export { ForwardRef as ReactComponent };